import { SpeechToTextPlayground } from "./features/speech-to-text-playground/speech-to-text-playground";
import "./index.css";

export function App() {
  return <SpeechToTextPlayground />;
}
